import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M4 5H20M4 9H13" vectorEffect="non-scaling-stroke" />
		<Path d="M12.5 13H6C5.30964 13 4.75 13.5596 4.75 14.25V19.541V21.6662C4.75 22.1282 5.32306 22.343 5.6268 21.9948L7.76724 19.541H12.5C13.1904 19.541 13.75 18.9813 13.75 18.291V14.25C13.75 13.5596 13.1904 13 12.5 13Z" vectorEffect="non-scaling-stroke" />
	</SVG>
);
